import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";

// 代行者一覧参照API
// API仕様書_代行者
import {
  IAPI_AGE001_Request,
  IAPI_AGE001_Response,
} from "../../../type/apiType";

// 代行者削除API
// API仕様書_代行者
import {
  IAPI_AGE004_Request,
  IAPI_AGE004_Response,
} from "../../../type/apiType";

// 代行者一覧参照API
// API仕様書_代行者
const httpAPI_AGE001 = async (
  param: IAPI_AGE001_Request
): Promise<IAPI_AGE001_Response> => {
  let res = await http.post(ApiUrl.API_AGE001, {
    ...param,
  });

  return res.data;
};

// 代行者削除API
// API仕様書_代行者
const httpAPI_AGE004 = async (
  param: IAPI_AGE004_Request
): Promise<IAPI_AGE004_Response> => {
  let res = await http.post(ApiUrl.API_AGE004, {
    ...param,
  });

  return res.data;
};

export { httpAPI_AGE001, httpAPI_AGE004 };
